<div class="mobile-brand-bar">
  <app-svg-loader *ngIf="currentTheme === 'dark-theme'" height="24px" url="assets/logos/tail-one-logo-white.svg?key=1"></app-svg-loader>
  <app-svg-loader *ngIf="currentTheme === 'light-theme'" height="24px" url="assets/logos/tail-one-logo-dark.svg?key=1"></app-svg-loader>
  <div class="cta-wrapper">
    {{ctaText}}
   </div>
</div>

<app-split-page-wrapper>
  <div left>
     <div class="brand-element">
      <div class="logo-wrapper">
        <div class="logo-ball"></div>
        <app-svg-loader *ngIf="currentTheme === 'dark-theme'" height="34px" url="assets/logos/tail-one-logo-white.svg?key=2"></app-svg-loader>
        <app-svg-loader *ngIf="currentTheme === 'light-theme'" height="34px" url="assets/logos/tail-one-logo-dark.svg?key=2"></app-svg-loader>
       </div>
       <div class="cta-wrapper">
        {{ctaText}}
       </div>
     </div>
  </div>
  <div right>
    <div class="auth-form-wrapper">
      
      <h2>Sign In</h2>

      <app-base-input id="email" placeholder="email" mb="14px" [(ngModel)]="email" type="email" isFluid="true"
        autocomplete="off"></app-base-input>

      <app-base-input id="password" placeholder="password" mb="14px" [(ngModel)]="password" type="password"
        (onEnter)="signIn()" isFluid="true" autocomplete="off"></app-base-input>

      <app-alert-message *ngIf="errorMessage" type="error" mb="24px">{{errorMessage}}</app-alert-message>

      <app-primary-btn (click)="signIn()" mb="24px" [disabled]="isAuthenticating" gradient="true">
        <span *ngIf="!isAuthenticating">Submit</span>
        <app-spinner variant="btn-spinner" *ngIf="isAuthenticating" size="20px"></app-spinner>
      </app-primary-btn>
      <button class="google-auth-btn" (click)="signInWithGoogle()">
        <div class="icon">
          <app-svg-loader height="18px" url="assets/third-party-logos/logo-google.svg"></app-svg-loader>
        </div>
        <div class="text">Continue with Google</div>
      </button>

     <div class="auth-link-wrap bordered right">
           <a class="link" [routerLink]="['/register']">Sign Up</a>
            <a class="link" [routerLink]="['/forgot']">Forgot Password</a>
      </div>
    </div>
  </div>

</app-split-page-wrapper>